var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg12PxCheckCircle = function Svg12PxCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 0C2.691 0 0 2.691 0 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m2.853 4.45-3.003 4a.75.75 0 0 1-.546.298l-.054.002a.75.75 0 0 1-.53-.219l-1.503-1.5A.75.75 0 1 1 4.279 5.97l.892.89 2.484-3.31a.75.75 0 1 1 1.199.901Z"
  })));
};
export default Svg12PxCheckCircle;